export default __webpack_public_path__ + "static/media/hand.4ca2b14d.svg";